import React, { useState, useEffect } from 'react';
import store, { applicationActions } from '@apply/adminStore';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ReviewerModal from '../../modals/ReviewerModal';
import { RefreshEvents } from '../../../../common/SharedEvents';
import { AppraisalsApi } from '@apply/api';
import { applicationInsights } from '../../../../ApplicationInsights';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faPlus } from '@fortawesome/free-solid-svg-icons';

export const ReviewerList = ({
    reviewerId,
    onChange = null,
    disabled = false,
    required = true,
    canEdit = true,
    showHeader = true,
}) => {
    const api = new AppraisalsApi.AppraisalsApi(applicationInsights);
    const { dispatch } = store;
    const refreshEvents = new RefreshEvents();

    const [reviewers, set_reviewers] = useState([]);

    const styles = {
        selector: { width: '250px' },
        edit_button: {
            marginLeft: '1px',
            height: '37px',
            width: '37px',
            borderRadius: '5px',
        },
        add_button: {
            marginLeft: '1px',
            height: '37px',
            width: '37px',
            borderRadius: '5px',
        },
    };

    useEffect(() => {
        async function load() {
            await loadReviewers();
            refreshEvents.addRefreshListener(loadReviewers);
            return () => {
                refreshEvents.removeRefreshListener(loadReviewers);
            };
        }

        load();
    }, []);

    const loadReviewers = async () => {
        const response = await api.appraisalReviewersList(reviewerId);
        if (response.statusCode !== 200) {
            return;
        }

        set_reviewers(response.result);
    };

    const addReviewer = () => {
        dispatch(
            applicationActions.setEditReviewerModal({
                editReviewerModal: {
                    isOpen: true,
                    reviewerId: 0,
                    onSave: onAfterEdit,
                },
            })
        );
    };

    const editReviewer = () => {
        dispatch(
            applicationActions.setEditReviewerModal({
                editReviewerModal: {
                    isOpen: true,
                    reviewerId,
                    onSave: onAfterEdit,
                },
            })
        );
    };

    const onAfterEdit = async (id) => {
        onChange && onChange(id);
    };

    const onReviewerSelect = (val) => {
        if (val) {
            onChange && onChange(parseInt(val));
        } else {
            onChange && onChange(null);
        }
    };

    return (
        <>
            <div style={{ width: '250px', float: 'left' }}>
                {showHeader && <label htmlFor='borrower-search'>Reviewer {required && <span className='req'>*</span>}</label>}
                <select
                    id='reviewerId'
                    value={reviewerId ?? ''}
                    required={required}
                    disabled={disabled}
                    onChange={(e) => onReviewerSelect(e.target.value)}
                >
                    <option value=''>Select...</option>
                    {reviewers &&
                        reviewers.map((r) => {
                            return (
                                <option
                                    key={r.key}
                                    value={r.key}
                                >
                                    {r.name}
                                </option>
                            );
                        })}
                </select>
            </div>
            <div style={{ float: 'left', width: '90px', paddingTop: '23px' }}>
                <button
                    type='button'
                    onClick={editReviewer}
                    className='button hollow'
                    style={styles.edit_button}
                    title='Edit Reviewer'
                    disabled={disabled || !canEdit || !reviewerId}
                >
                    <FontAwesomeIcon icon={faPencil} />
                </button>
                <button
                    type='button'
                    onClick={addReviewer}
                    className='button hollow'
                    style={styles.add_button}
                    title='Add new Reviewer'
                    disabled={disabled}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>
            <ReviewerModal />
        </>
    );
};
